import {css} from 'styled-components'

export const UtilStyles = css`
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
    color: transparent;
    background-color: transparent;
  }
`
